"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReferralFirstRefereePayoutMockData = exports.buildReferralFirstRefereeTransactionMockData = exports.buildReferralDuringOnboardingMockData = exports.buildReferralDuringSignUpMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const REFERRAL_LINK = "https://www.zeffy.com/en-US/referral?code=MOCK1234";
const REFERRAL_AMOUNT = "$50";
const buildReferralDuringSignUpMockData = ({ locale = "en", subject = "Riverside Youth Soccer signed up with your referral link!", firstName = "John", orgName = "Riverside Youth Soccer", referralLink = REFERRAL_LINK, referralAmount = REFERRAL_AMOUNT, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    orgName,
    referralLink,
    referralAmount,
});
exports.buildReferralDuringSignUpMockData = buildReferralDuringSignUpMockData;
const buildReferralDuringOnboardingMockData = ({ locale = "en", subject = "Riverside Youth Soccer completed onboarding with your referral link!", firstName = "John", orgName = "Riverside Youth Soccer", referralLink = REFERRAL_LINK, referralAmount = REFERRAL_AMOUNT, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    orgName,
    referralLink,
    referralAmount,
});
exports.buildReferralDuringOnboardingMockData = buildReferralDuringOnboardingMockData;
const buildReferralFirstRefereeTransactionMockData = ({ locale = "en", subject = "You earned a referral bonus!", amount = "$120.00", referralLink = REFERRAL_LINK, referralAmount = REFERRAL_AMOUNT, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    amount,
    referralLink,
    referralAmount,
});
exports.buildReferralFirstRefereeTransactionMockData = buildReferralFirstRefereeTransactionMockData;
const buildReferralFirstRefereePayoutMockData = ({ locale = "en", subject = "Congratulations on your first payout!", firstName = "John", referrerOrgName = "Lakeside Community Fund", referralLink = REFERRAL_LINK, referralAmount = REFERRAL_AMOUNT, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    referrerOrgName,
    referralLink,
    referralAmount,
});
exports.buildReferralFirstRefereePayoutMockData = buildReferralFirstRefereePayoutMockData;
